import React from 'react';
import { IonAlert, IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import { Title, Spacer, NormalText, SmallText, StrongText, Subtitle } from '../../components/common';
import { isWebConfig } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import { chevronBackOutline, chevronForwardOutline, informationCircleOutline, lockClosed } from 'ionicons/icons';
import './index.css';
import { VoucherItem } from '../../screens/voucher';
import { withRouter } from 'react-router';
import { buyReward, getUnlockRewardsInfo } from '../../store/actions';
import Slider, { Slide } from '../../components/slider';

const RewardItem = ({ reward, id, __, action }) => {
	return (
		<div onClick={() => action(id)} className="loyalty-reward pointer" >
			<img src={reward.reward.image} />
			<div className="loyalty-reward-name">
				<StrongText className="block">{`${reward.stamps_required} ${__('points')}`}</StrongText>
				<SmallText>{reward.name}</SmallText>
			</div>
		</div>
	);
};

class UnlockRewardItmes extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedReward: null,
			buyRewardModalOpen: false,
			rewardInfoModalOpen: false,
			current: 0
		};

	}

	componentDidMount() {
		this.props.dispatch(getUnlockRewardsInfo());
	}
	buyReward = (reward) => {
		this.props.dispatch(buyReward({ atreemo: reward.source == 'atreemo',rewardId: reward.id, fromOrder: this.props?.location?.state?.fromOrder ? true : false }));
	};
	viewReward = (id) => {
		const { rewards } = this.props;
		this.setState({ selectedReward: rewards.find((r) => r.id === id) });
	};

	render() {
		const { __, available_balance, rewards, unlockRewardsInfo } = this.props;
		const { selectedReward, rewardInfoModalOpen } = this.state;
		return (
			<>
				<>
					<div style={{ display: 'grid', gridAutoFlow: 'column', gridTemplateColumns: '1fr auto' }} onClick={() => this.setState({ rewardInfoModalOpen: true })}>
						<Title className='page-title-centered'>{__('Unlock rewards')}</Title>
						<Spacer size={2} />
						<IonIcon
							className='text-color'
							style={{ cursor: 'pointer', height: '24px', width: '24px' }}
							onClick={() => {
								this.setState({ rewardInfoModalOpen: true });
							}}
							icon={informationCircleOutline}
						/>
					</div>

					<div style={{ overflow: 'hidden', display: 'block' }} className="loyalty-rewards-wrapper"
					>
						<Slider
							settings={{
								slidesPerView: rewards.length == 1 ? 1 : 1.4,
								spaceBetween: 8,
								slidesOffsetBefore: 0,
								centeredSlides: false,
								loop: false
							}}
						>
							{rewards.map((reward, index) => (
								<Slide key={'rw-' + index} className={`${rewards.length == 1 ? 'single-slide' : ''}`} >
									<RewardItem reward={reward} __={__} available_balance={available_balance} action={() => this.viewReward(reward.id)} />

								</Slide>
							))}
						</Slider>
					</div>
				</>
				<Modal
					className="voucher-modal unlock-rewards-modal"
					isOpen={selectedReward !== null}
					onDidDismiss={() => {
						this.setState({ selectedReward: null });
						this.props.history.replace({ state: {} });
					}}
				>
					{selectedReward && selectedReward.reward ? (
						<div >
							<Title className='modal-title'>{__('Redemption details')}</Title>
							<Spacer size={2} />
							<VoucherItem onlyImage {...selectedReward} __={__} />
							<Spacer size={2} />
							<Subtitle className="bold">{selectedReward.name}</Subtitle>
							<NormalText>{`${selectedReward.stamps_required} ${__('points required')}`}</NormalText>

							<Spacer size={5} />
							<div className="voucher-modal-content">{selectedReward.reward.description ? <div dangerouslySetInnerHTML={{ __html: selectedReward.reward.description }} /> : null}</div>
							<Spacer size={5} />

							<IonButton
								disabled={available_balance < selectedReward.stamps_required}
								onClick={() => this.setState({ buyRewardModalOpen: true })}
								style={{ margin: 0 }}
								expand="block"
								color="primary"
								className='button-uppercase'
							>
								{available_balance < selectedReward.stamps_required && <IonIcon style={{ height: '15px', width: '15px', marginRight: '5px' }} icon={lockClosed} />}

								{`${__('Redeem for')} ${selectedReward.stamps_required} ${__('points')}`}
							</IonButton>
							<Spacer size={2} />
							<SmallText className="block centered">
								{__('You have')} {available_balance} {available_balance == 1 ? __('point') : __('points')}
							</SmallText>
						</div>
					) : null}
				</Modal>
				<IonAlert
					isOpen={this.state.buyRewardModalOpen}
					onDidDismiss={() => this.setState({ buyRewardModalOpen: false })}
					header={__('Are you sure?')}
					message={__(selectedReward?.stamps_required == 1 ? 'Are you sure you wish to redeem {count} point in exchange for the following voucher: {name}' : 'Are you sure you wish to redeem {count} points in exchange for the following voucher: {name}', { count: selectedReward?.stamps_required, name: selectedReward?.name })}
					buttons={[
						{
							text: __('Redeem'),
							cssClass: 'primary',
							handler: () => this.buyReward(selectedReward),
						},
						{
							text: __('Cancel'),
							role: 'cancel',
							cssClass: 'secondary link',
						},

					]}
				/>
				<Modal
					className="loyalty-faq-modal"
					isOpen={rewardInfoModalOpen}
					onDidDismiss={() => {
						this.setState({ rewardInfoModalOpen: false });
					}}
				>
					<div className="lefted">
						<Title>{__('Unlock Rewards')}</Title>
						<div dangerouslySetInnerHTML={{ __html: unlockRewardsInfo }}></div>
					</div>{' '}
				</Modal>
			</>
		);
	}
}
const stateToProps = (state) => {
	const { profile, auth } = state.profile;
	const { history } = state.orders;

	return {
		history,
		vouchers: state.profile.vouchers || [],
		qr_code: state.profile.profile.qr_code,
		profile,
		auth,
		unlockRewardsInfo: state.common.unlockRewardsInfo,
	};
};
export default connect(stateToProps)(withRouter(withTranslation(UnlockRewardItmes)));
